module.exports = __webpack_public_path__ + "static/media/14_4.8c04c28d.jpg";